import type { AppRouter } from "@chaski/bff";
import type { ERROR_KEYS } from "@chaski/bff/api/server/error-markers";
import { TRPCClientError } from "@trpc/react-query";

const PLANNER_SESSION_NOT_SEEDED_ERROR_KEY =
  "PLANNER_SESSION_NOT_SEEDED" satisfies (typeof ERROR_KEYS)["PLANNER_SESSION_NOT_SEEDED"];

export function isTRPCClientError(
  cause: unknown,
): cause is TRPCClientError<AppRouter> {
  return cause instanceof TRPCClientError;
}

export function getStatusCodeFromTRPCError(error: unknown): number | undefined {
  if (isTRPCClientError(error)) {
    return error.data?.httpStatus;
  }
  return undefined;
}

export function getErrorKeyFromTRPCError(error: unknown): string | undefined {
  if (!isTRPCClientError(error)) {
    return undefined;
  }

  const data = error.data as { errorKey?: string } | undefined;
  return data?.errorKey;
}

export function isPlannerSessionNotSeededTRPCError(error: unknown): boolean {
  return (
    getErrorKeyFromTRPCError(error) === PLANNER_SESSION_NOT_SEEDED_ERROR_KEY
  );
}
